import { WebMercatorViewport } from '@deck.gl/core/typed';
import { DeckTransitionProps } from 'components/maps/MapContext';
import { Dispatch, SetStateAction, useCallback } from 'react';
import { ViewState } from 'react-map-gl/maplibre';

export const useFitBounds = ({
  setViewState,
  mercatorViewPort,
}: {
  setViewState: Dispatch<SetStateAction<Partial<ViewState> & DeckTransitionProps>>;
  mercatorViewPort: WebMercatorViewport;
}) => {
  return useCallback(
    (
      bounds: [[number, number], [number, number]],
      bearing?: number,
      pitch?: number,
      transition?: DeckTransitionProps
    ) => {
      try {
        const result = mercatorViewPort.fitBounds([bounds[0], bounds[1]], {});
        setViewState({
          bearing: bearing ?? result.bearing,
          latitude: result.latitude,
          longitude: result.longitude,
          pitch: pitch ?? result.pitch,
          zoom: result.zoom,
          ...transition,
        });
      } catch (e) {
        try {
          console.warn('failed to fit bounds, trying again flipping the bounds', e);
          // try again with flipped bounds
          const result = mercatorViewPort.fitBounds(
            [
              [bounds[0][1], bounds[0][0]],
              [bounds[1][1], bounds[1][0]],
            ],
            {}
          );
          setViewState({
            bearing: bearing ?? result.bearing,
            latitude: result.latitude,
            longitude: result.longitude,
            pitch: pitch ?? result.pitch,
            zoom: result.zoom,
            ...transition,
          });
        } catch (e) {
          console.error('failed to fit bounds', e);
        }
      }
    },
    [mercatorViewPort, setViewState]
  );
};
